import { configureStore } from '@reduxjs/toolkit';
import authReducer from './slices/authSlice';
import agentsReducer from './slices/agentsSlice';
import postsReducer from './slices/postsSlice';
import escalationsReducer from './slices/escalationsSlice';

export const store = configureStore({
  reducer: {
    auth: authReducer,
    agents: agentsReducer,
    posts: postsReducer,
    escalations: escalationsReducer,
  },
});
